import AWS from 'aws-sdk';
import config from '../../config';

const S3_BUCKET = config.aws.s3.motiliFiles.bucketName;
const REGION = 'us-west-2';

AWS.config.update({
    region: REGION,
    credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: config.aws.s3.motiliFiles.identityPoolId,
    }),
});

const myBucket = new AWS.S3({
    apiVersion: '2006-03-01',
    params: { Bucket: S3_BUCKET },
});

export const uploadFileToBucket = (
    fileDomain: 'contractor' | 'client',
    uuid: string,
    fileName: string,
    file: File
) => {
    const filePath = `${fileDomain}/${uuid}/${fileName}${Date.now()}-${
        file.name
    }`;
    const params = {
        Body: file,
        Bucket: S3_BUCKET as string,
        Key: filePath,
        ContentType: file.type,
    };

    return new Promise<{
        storedFileUrl: string;
        key: string;
        bucket: string;
        source: string;
    }>((resolve, reject) => {
        myBucket.putObject(params).send(err => {
            if (err) reject(err);
            else {
                resolve({
                    storedFileUrl: `https://${S3_BUCKET}.s3.${REGION}.amazonaws.com/${filePath}`,
                    key: filePath,
                    bucket: S3_BUCKET,
                    source: 's3',
                });
            }
        });
    });
};

export const contractorVendorPacketUrl: string = `https://res.cloudinary.com/motili/image/upload/v1657197995/contractor-registration/Motili_Vendor_Packet_061422_Registration.pdf`;
